module.exports = __webpack_public_path__ + "media/src/images/dandori/step-complete-sm-592e2569d04e70be28c301b23b0c7670.png";